module.exports = __webpack_public_path__ + "static/media/avatars_male_22.1a35e6ca.png";